import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { CATEGORIES } from "@/lib/data";

export default function AllResources() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => {
    api.get("/resources").then((r) => setItems(r.data.items || []));
  }, []);
  const filtered = cat === "all" ? items : items.filter((i) => i.category === cat);

  return (
    <div data-testid="all-resources-page">
      <h1 className="text-5xl md:text-6xl font-semibold tracking-tight h-gradient">Tüm Ücretsiz Kaynaklar</h1>
      <p className="mt-5 text-neutral-400 max-w-2xl">10 yaşam alanının tamamına ait ücretsiz rehberler, checklist'ler ve mini planlar. Hepsi tek bir yerde.</p>

      <div className="flex flex-wrap gap-2 mt-8">
        <button onClick={() => setCat("all")} className={`px-4 py-2 rounded-full text-sm border ${cat === "all" ? "bg-white text-black border-white" : "border-white/10 text-neutral-300 hover:border-white/30"}`} data-testid="all-resources-filter-all">Tümü</button>
        {CATEGORIES.map((c) => (
          <button key={c.key} onClick={() => setCat(c.key)} className={`px-4 py-2 rounded-full text-sm border ${cat === c.key ? "bg-white text-black border-white" : "border-white/10 text-neutral-300 hover:border-white/30"}`} data-testid={`all-resources-filter-${c.key}`}>{c.label}</button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {filtered.map((r) => (
          <div key={r.id} className="glass p-6 flex flex-col" data-testid={`all-resource-${r.id}`}>
            <span className="self-start px-3 py-1 rounded-full border border-white/12 text-[10px] uppercase tracking-[0.15em] text-neutral-300">Ücretsiz</span>
            <div className="text-xs text-neutral-500 mt-3 uppercase tracking-[0.12em]">{r.category_label}</div>
            <h3 className="text-lg font-semibold mt-2 text-white">{r.title}</h3>
            <p className="mt-2 text-sm text-neutral-400 leading-relaxed flex-1">{r.description}</p>
            <Link to={`/kaynaklar/${r.id}`} className="btn-primary mt-5 inline-flex items-center justify-center gap-2 text-sm">
              Kaynağı Aç <ArrowRight size={14} />
            </Link>
          </div>
        ))}
        {filtered.length === 0 && <div className="col-span-full text-center text-neutral-500 py-12">Bu kategoride kaynak yok.</div>}
      </div>
    </div>
  );
}
